import React, {Component} from 'react';
import {pageWithPrismic} from "../website-gridhaus/pageWithPrismic";
import {RichText} from "prismic-reactjs";
import {routes, site} from "../config";
import {Link} from "react-router-dom";
import DownArrow from "../parts/DownArrow";
import {Helmet} from "react-helmet";
import {metaDescriptions, metaTitles} from "../website-gridhaus/meta";
import {fetchArticlesIfNeeded, openSubscribePopup} from "../redux/actions";
import {store} from '../index';


class BlogPage extends Component {
  componentDidMount() {
    window.analytics.page("Blog");
    !window.suppressSubscribePopup && store.dispatch(openSubscribePopup());
  }

  render() {
    window.prerenderReady = false;
    if (this.props.page && this.props.page.doc) {
      window.prerenderReady = !!this.props.articles;
      const data = this.props.page.doc.data;
      return (
        <div className={'page-blog'}>
          <Helmet>
            <title>{site.titlePrefix + 'Blog'}</title>
            {metaTitles(site.titlePrefix + 'Blog')}
            {metaDescriptions(RichText.asText(data.hero_message))}
          </Helmet>
          <section className={'hero'} id={'hero'}>
            <div className={'container'}>
              <h1 className={'title'}>{data.hero_title}</h1>
              <div className={'brief'}>{RichText.render(data.hero_message)}</div>
            </div>
            <DownArrow scrollPastId={'hero'}/>
          </section>
          <section className={'content'}>
            <div className={'container'}>
              {(!this.props.articles) ? null : (
                <ul className={'articles'}>
                  {this.props.articles.filter(article => article.data.status !== 'Internal').map((article) => {
                    const data = article.data;

                    return (
                      <li key={article.uid}>
                        <div className={'image'}>
                          <Link to={routes.blog + '/' + article.uid}>
                            <img src={data.image.url} alt={data.image.alt}/>
                          </Link>
                        </div>
                        <div className={'category'}>{data.category}</div>
                        <div className={'title'}>
                          <Link to={routes.blog + '/' + article.uid}>
                            {data.title}
                          </Link>
                        </div>
                        <div className={'description'}>{data.description}</div>
                        <Link className={'read-more'} to={routes.blog + '/' + article.uid}>
                          Read more
                        </Link>
                      </li>
                    )
                  })}
                </ul>
              )}
            </div>
          </section>
        </div>
      )
    }

    return null;
  }
}


export default pageWithPrismic(BlogPage, 'blog_page',
  (state) => {
    return {
      articles: state.articles.items
    }
  },
  [fetchArticlesIfNeeded]
);


// WEBPACK FOOTER //
// ./src/pages/BlogPage.js